import { useState } from "react";
import type { Station } from "../lib/m3u";

export default function StationLogo({ station, className }: { station: Station; className: string }) {
  const [failedLogo, setFailedLogo] = useState<string | null>(null);

  if (station.logo && station.logo !== failedLogo) {
    return (
      <img
        src={station.logo}
        alt=""
        loading="lazy"
        onError={() => setFailedLogo(station.logo ?? null)}
        className={`shrink-0 rounded-md bg-slate-100 object-contain ${className}`}
      />
    );
  }

  return (
    <div className={`flex shrink-0 items-center justify-center rounded-md bg-slate-200 font-semibold text-slate-500 ${className}`}>
      {station.name.charAt(0).toUpperCase()}
    </div>
  );
}
